import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import { useSpring, animated } from '@react-spring/web';
import {
  Flex,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Text,
  Box
} from "@chakra-ui/react";
import Card from "components/card/Card.js";

export default function MiniStatistics({ startContent, name, value }) {
  const textColor = useColorModeValue("gray.800", "white");
  const [target, setTarget] = useState(0);
  const [celebrate, setCelebrate] = useState(false);

  const { width, height } = useWindowSize();

  const propsAnim = useSpring({
    val: value,
    from: { val: 0 }
  });

  useEffect(() => {
    if (value !== target) {
      setTarget(value);
      if (value % 100 === 0 && value !== 0) {
        setCelebrate(true);
        setTimeout(() => setCelebrate(false), 5000); // Stop celebration after 5 seconds
      }
    }
  }, [value, target]);

  return (
    <Card py="62px">
      {celebrate && <Confetti width={width} height={height} numberOfPieces={400} />}
      <Flex
        flexDirection="row" textAlign="center"
      >
        <Box flexShrink={0} width="auto" height="auto" p="10px">
          {startContent}
        </Box>

        <Stat>
          <StatLabel fontSize="2xl">{name}</StatLabel>
          <StatNumber fontSize="2xl">
            <animated.div>
              {propsAnim.val.to(val => Math.floor(val))}
            </animated.div>
          </StatNumber>
        </Stat>
      </Flex>
    </Card>
  );
}
